const NexaMark = ({ size = 22 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true" className="tw-shrink-0">
    <path d="M16 17.2 29 22.4 16 27.6 3 22.4Z" fill="#6C5BFF" fillOpacity=".32" />
    <path d="M16 11.4 29 16.6 16 21.8 3 16.6Z" fill="#6C5BFF" />
    <path d="M16 5.2 29 10.4 16 15.6 3 10.4Z" fill="#A3E635" />
  </svg>
);

export default NexaMark;
